
import { MapLocation } from '@/types/location';

// Fat2Fit Gym Locations
export const fat2FitGyms: MapLocation[] = [
  {
    id: 17001,
    name: "Fat2Fit Gym - Riyadh (As Suwedi)",
    type: "Gym",
    devices: 2,
    coordinates: [24.61340067198747, 46.63879922723938],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "18-51",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
